<script setup lang="ts">
import { type AnnouncementBarData } from '@laam/cms-shared';
import AnnouncementBar from './AnnouncementBar.vue';

interface AnnouncementBarProps {
	data: AnnouncementBarData;
}

const props = defineProps<AnnouncementBarProps>();

const hasAnnouncements = computed(() => {
	if (props.data && props.data.announcements.length === 0) {
		return false;
	}
	return true;
});
</script>

<template>
	<AnnouncementBar
		v-if="hasAnnouncements"
		:announcements="data.announcements"
	/>
</template>
